import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-competency-insights',
  templateUrl: './competency-insights.component.html',
  styleUrls: ['./competency-insights.component.css']
})
export class CompetencyInsightsComponent implements OnInit {

  arrayOf: Array<any> = [
    {
      id: 1,
      name: "Resources"
    },
    {
      id: 2,
      name: "Projects"
    },
    {
      id: 3,
      name: "Tasks"
    },
    {
      id: 2,
      name: "Projects"
    },
    {
      id: 3,
      name: "Tasks"
    }
  ];
  

  constructor() { }

  ngOnInit() {
  }

}
